import {columnsTableTendVeh as columnsTableTendVeh_v1,subTitlesTableTendVeh as subTitlesTableTendVeh_v1} from './columns_TENDVEH';
import {columnsTableTendVeh as columnsTableTendVeh_v2,subTitlesTableTendVeh as subTitlesTableTendVeh_v2} from './columns_TENDVEH_v2';

export const columnsTableTendVeh = (idVersion) => {
    console.log('columnsTableTendVeh IdVersion: ',idVersion)
    switch (idVersion) {
        case 1:
            console.log('dentro IdVersion: ',idVersion)
            return columnsTableTendVeh_v2;
        default: 
            return columnsTableTendVeh_v1;
    }
}

export const subTitlesTableTendVeh = (idVersion) => {
    switch (idVersion) {
        case 1:
            return subTitlesTableTendVeh_v2;
        default: 
            return subTitlesTableTendVeh_v1;
    }
}